import * as firebase from "firebase";

export interface IApplicationState {
  login: ILoginState;
  session: ISessionState;
}

export interface ILoginState {
  email: string;
  password: string;
}

export interface ISessionState {
  user: firebase.User | null;
}

export const DEFAULT_STATE: IApplicationState = {
  login: {
    email: "",
    password: ""
  },
  session: {
    user: null
  }
};



// WEBPACK FOOTER //
// ./src/models/state.ts